import React, { useEffect, useState } from "react";
import { HistoryDetailsWrapper } from "./styled";
import {
  BackButton,
  Box,
  LabelStyled,
  ThemeLoader,
} from "../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import ListTable from "../../../components/common/tables/ListTable";
import { historyDetailColumns } from "../../../helpers/adminConstants/TableConstants";
import { InformationRowWrapper } from "../../../components/styled/styled";
import FormRadio from "../../../components/common/radioButtons/FormRadio";
import { PlaceholderImg } from "../../../components/styled/AllImages";
import { Col } from "react-bootstrap";
import DatePickerDefault from "../../../components/common/inputFields/DatePicker";
import { UsersDropdown } from "../../../components/common/dropdowns/DropdownInputs";
import Breadcrumbs from "../../../components/admin/Breadcrumbs/Breadcrumbs";
import { useForm } from "react-hook-form";
import HistoryApi from "../../../services/api/historyApi";
import {
  getFormattedDate,
  getFormattedTime,
  getFormattedTimeWithSec,
  reqFormatDate,
} from "../../../utils";
import { useSelector } from "react-redux";
import { useUser } from "../../../context/userContext";

const HistoryDetails = () => {
  const navigate = useNavigate();
  const { user } = useUser();
  const { id } = useParams();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  // States
  const { usersList } = useSelector((state) => state.helper);
  const [selectedDate, setSelectedDate] = useState();
  const [filterParams, setFilterParams] = useState({ search_type: "all" });
  const [historyDetail, setHistoryDetail] = useState([]);
  const [isLoadingHistDetail, setIsLoadingHistDetail] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [perPage, setPerPage] = useState(null);
  const [totalCount, setTotalCount] = useState(null);
  const [archiveDetail, setArchiveDetail] = useState({});
  const [existedUsersList, setExistedUsersList] = useState([]);
  const ASSET_URL = process.env.REACT_APP_ASSET_URL;

  const { control, reset } = useForm();

  const onChange = (e) => {
    const { name, value } = e.target;

    if (filterParams.search_type) {
      reset();
      setFilterParams((prev) => ({
        ...prev,
        search_date: null,
        search_name: null,
      }));
    }

    setFilterParams((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const updateDate = (name, value) => {
    setFilterParams((prevData) => ({
      ...prevData,
      [name]: reqFormatDate(value),
    }));
  };

  const getHistoryDetail = async (page, query) => {
    try {
      setIsLoadingHistDetail(true);
      const { data, code } = await HistoryApi.getHistoryDetail(id, page, query);
      if (code === 200) {
        // const filteredExistedUsersList = data?.data?.map((item) => ({
        //   profile: item?.user?.profile,
        //   name: item?.user?.name,
        //   role: item?.user?.position,
        //   subLabel: `${
        //     language === "en"
        //       ? item.user.user_detail.department_selective.name_en
        //       : item.user.user_detail.department_selective.name_ar
        //   } (${
        //     language === "en"
        //       ? item.user.user_detail.office_location_selective.name_en
        //       : item.user.user_detail.office_location_selective.name_ar
        //   })`,
        // }));
        // const filteredExistedUsersList = [];
        const formattedHistDetail =
          data?.data &&
          data?.data?.length > 0 &&
          data?.data?.map((item) => {
            const formattedItem = {
              id: item?.user_id,
              date: getFormattedDate(item?.last_action_date),
              time: getFormattedTime(item?.last_action_date),
              username: item?.user?.name,
              user_info: {
                img: item?.user?.profile
                  ? `${ASSET_URL}/${item?.user?.profile}`
                  : PlaceholderImg,
                name: item?.user?.name,
                role: item?.user?.position,
                subLabel: item?.user?.user_detail?.department_selective
                  ? `${
                      language === "en"
                        ? item?.user?.user_detail?.department_selective?.name_en
                        : item?.user?.user_detail?.department_selective?.name_ar
                    } (${
                      language === "en"
                        ? item?.user?.user_detail?.office_location_selective
                            ?.name_en
                        : item?.user?.user_detail?.office_location_selective
                            ?.name_ar
                    })`
                  : null,
                data: [
                  {
                    title: "branch",
                    value:
                      language === "en"
                        ? item?.user?.user_detail?.office_location_selective
                            ?.name_en
                        : item?.user?.user_detail?.office_location_selective
                            ?.name_ar,
                  },
                  {
                    title: "department",
                    value:
                      language === "en"
                        ? item?.user?.user_detail?.department_selective?.name_en
                        : item?.user?.user_detail?.department_selective
                            ?.name_ar,
                  },
                ],
              },
              view: Boolean(item?.viewed),
              download: Boolean(item?.downloaded),
            };
            return formattedItem;
          });

        setHistoryDetail(formattedHistDetail);
        setTotalCount(data?.total);
        setPerPage(data?.per_page);

        const uniqueUserIds = new Set();
        const filteredExistedUsersList = data?.data?.reduce((acc, item) => {
          const userId = item?.user_id;

          if (!uniqueUserIds.has(userId)) {
            uniqueUserIds.add(userId);

            acc.push({
              user_id: userId,
              profile: item?.user?.profile,
              name: item?.user?.name,
              role: item?.user?.position,
              subLabel:
                item?.user?.user_detail?.department_selective &&
                item?.user?.user_detail?.department_selective
                  ? `${
                      language === "en"
                        ? item?.user?.user_detail?.department_selective?.name_en
                        : item?.user?.user_detail?.department_selective?.name_ar
                    } (${
                      language === "en"
                        ? item?.user?.user_detail?.office_location_selective
                            ?.name_en
                        : item?.user?.user_detail?.office_location_selective
                            ?.name_ar
                    })`
                  : null,
            });
          }

          return acc;
        }, []);
        setExistedUsersList(filteredExistedUsersList);
      } else {
        setHistoryDetail([]);
        setTotalCount(null);
        setPerPage(null);
      }
    } catch (error) {
    } finally {
      setIsLoadingHistDetail(false);
    }
  };

  const getArchiveDetail = async (archiveId) => {
    const { data, code } = await HistoryApi.getArchiveDetail(archiveId);
    if (code === 200) {
      data && setArchiveDetail(data);
    }
  };

  useEffect(() => {
    getArchiveDetail(id);
  }, []);

  useEffect(() => {
    getHistoryDetail(activePage, filterParams);
  }, [activePage, filterParams, language]);

  return (
    <HistoryDetailsWrapper>
      <Box className="content-head">
        <Box className="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 gap-md-5">
          <BackButton
            label={t("view_history")}
            onClick={() => navigate("/access-log")}
          />
          <Breadcrumbs />
        </Box>
      </Box>
      <Box>
        <InformationRowWrapper className="m-3">
          <div className="table-content">
            <div className="column">
              <div className="column-label">{t("Archive")}</div>
              <div className="column-value">{archiveDetail?.title}</div>
            </div>
            <div className="column">
              <div className="column-label">{t("date")}</div>
              <div className="column-value">
                {archiveDetail?.created_at &&
                  getFormattedDate(archiveDetail?.created_at)}
              </div>
            </div>
            <div className="column">
              <div className="column-label">{t("number")}</div>
              <div className="column-value">{archiveDetail?.number}</div>
            </div>
            <div className="column">
              <div className="column-label">{t("cabinet_name")}</div>
              <div className="column-value">
                {archiveDetail?.file_name?.cabinet_name?.name}
              </div>
            </div>
            <div className="column">
              <div className="column-label">{t("FileName")}</div>
              <div className="column-value">
                {archiveDetail?.file_name?.name}
              </div>
            </div>
          </div>
        </InformationRowWrapper>
        <Box className="row mx-2">
          <Col className="my-2">
            <Box className="d-flex type-select-box">
              <LabelStyled size="14px" className="mx-2">
                {t("type")}
              </LabelStyled>
              <Box className="d-flex filters-list">
                <Box>
                  <FormRadio
                    name="search_type"
                    subLabel={t("all")}
                    value="all"
                    checked={filterParams.search_type === "all"}
                    onChange={onChange}
                  />
                </Box>
                <Box>
                  <FormRadio
                    name="search_type"
                    subLabel={t("views")}
                    value="view"
                    checked={filterParams.search_type === "view"}
                    onChange={onChange}
                  />
                </Box>
                <Box>
                  <FormRadio
                    name="search_type"
                    subLabel={t("downloads")}
                    value="download"
                    checked={filterParams.search_type === "download"}
                    onChange={onChange}
                  />
                </Box>
              </Box>
            </Box>
          </Col>
          <Col className="my-2">
            <DatePickerDefault
              name="search_date"
              control={control}
              selectedDate={selectedDate}
              setSelectedDate={setSelectedDate}
              placeholder={t("search_by_date")}
              style={{ minWidth: "180px" }}
              onDateChange={updateDate}
            />
          </Col>
          <Col className="my-2">
            <UsersDropdown
              placeholder={t("search_by_user")}
              optionsList={existedUsersList}
              onChange={onChange}
              name="search_name"
              viewAll={true}
            />
          </Col>
          {/* <Col className="my-2">
            <FloatingInput
              name="search"
              type="input"
              fieldType="text"
              label={t("search")}
              placeholder={t("search")}
              bg="var(--white)"
              icon={SearchIcon}
            />
          </Col> */}
        </Box>
        {isLoadingHistDetail ? (
          <ThemeLoader />
        ) : (
          <ListTable
            rows={historyDetail}
            columns={historyDetailColumns}
            perPage={perPage}
            activePage={activePage}
            setActivePage={setActivePage}
            totalCount={totalCount}
          />
        )}
      </Box>
    </HistoryDetailsWrapper>
  );
};

export default HistoryDetails;
